

const decodeToken = (newToken = "") => {
  const token = newToken ? newToken : localStorage.getItem("token");
    if(token) {
      const parts = token.split('.');
  
      if (parts.length === 3) {
        const base64Url = parts[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        return JSON.parse(atob(base64));        
      } else {
        return null
      }
    }
    
    return null
  }

  export default decodeToken;